import { render, staticRenderFns } from "./SocialMediaButton.vue?vue&type=template&id=28244fb9&scoped=true&"
import script from "./SocialMediaButton.vue?vue&type=script&lang=ts&"
export * from "./SocialMediaButton.vue?vue&type=script&lang=ts&"
import style0 from "./SocialMediaButton.vue?vue&type=style&index=0&id=28244fb9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28244fb9",
  null
  
)

export default component.exports